import Utils from "../../services/Utils.js";
import { getLiveMatch, getLiveStreamLink } from "../../js/api/liveMatch.js";
import {
  getInsideSingleColumn,
  getSingleColumnModule,
} from "../templates/singleColumnModule.js";
import TranslationService, { _t } from "../../services/TranslationService.js";
import Timeline from "../components/Timeline.js";
import { getUserGroup, transformSingleCoef } from "../../services/UserGroup.js";
import { parseResultList } from "../templates/live-games.js";
import { isSportBlocked } from "../../services/BlockedSports.js";

var gameId = 0;
let groupMatchHomeName = "";
let groupMatchAwayName = "";
let gameApiID = null;
let lang = localStorage.getItem("lang") ?? TranslationService.defaultLang;
let multipeResults = "";
let sportFieldId = null;
let blockedSportRedirect = false;

const cornerCategoryId = 29;
let numberOfCorners = null;
let cornerRefreshInterval = null;

let LiveMatch = {
  render: async () => {
    blockedSportRedirect = false;
    let upDownMarkets = [12, 16];
    let oneTwo = [7, 8, 9, 18];
    let request = Utils.parseRequestURL();
    if (request.query && request.query.sportid) {
      localStorage.setItem("inplay-sportid", request.query.sportid);
    }

    let sportId = localStorage.getItem("inplay-sportid");
    let sportName = "";
    switch (parseInt(sportId)) {
      case 1:
        sportName = "Soccer";
        break;
      case 2:
        sportName = "Basketball";
        break;
      case 5:
        sportName = "Tennis";
        break;
      case 20:
        sportName = "Ping Pong";
        break;
      default:
        sportName = "Other Sports";
        break;
    }

    sportFieldId = localStorage.getItem("inplay-sportid");

    gameId = request.id;
    let groupMatches = (await getLiveMatch(request.id)) || [];
    let groupMatchView = "";
    let matchView = "";
    let groupMatchDate = "";
    let scrollMeContent = "";
    let result = "";
    let liveStreamId = null;
    let leagueName = "";
    let currentMinute = "";

    if (!groupMatches.length) {
      window.history.back();
      return;
    }

    const firstMatch = groupMatches?.[0]?.[0];
    const resolvedSportId = firstMatch?.sport_id ?? sportId;

    if (isSportBlocked(resolvedSportId)) {
      blockedSportRedirect = true;
      window.location.hash = "#/inplay";
      return "";
    }

    if (resolvedSportId !== null && resolvedSportId !== undefined) {
      sportFieldId = String(resolvedSportId);
      localStorage.setItem("inplay-sportid", sportFieldId);
    }

    try {
      if (groupMatches.length > 0) {
        liveStreamId = groupMatches[0][0].stream_id;
        gameApiID = groupMatches[0][0].game_api_id;
        multipeResults = parseResultList(
          groupMatches[0][0].result,
          groupMatches[0][0].result_list,
          false,
          sportFieldId
        );
      }
    } catch {}

    if (firstMatch && firstMatch.home_team) {
      currentMinute = firstMatch.current_minute || "";
      groupMatchHomeName = firstMatch.home_team || "";
      groupMatchAwayName = firstMatch.away_team || "";
      groupMatchDate = firstMatch.game_date || "";
      result = firstMatch.result || "";
      leagueName = firstMatch.league_name || "";
    } else {
      currentMinute = "";
      groupMatchHomeName = "";
      groupMatchAwayName = "";
      groupMatchDate = "";
      result = "";
      leagueName = "";
    }

    if (
      !(
        groupMatches.length == 1 &&
        groupMatches[0].length == 1 &&
        !groupMatches[0][0].odd
      )
    ) {
      let acc = groupMatches.map(function (item) {
        return {
          market_category_id: item[0].market_category_id,
          mainCategory: item[0].mainCategory,
          mainCategoryID: item[0].mainCategoryID,
          marketId: item[0].market_category_id ? -1 : item[0].market_id,
        };
      });

      const uniqueCategories = [];

      $.each(acc, function (i, el) {
        const res = uniqueCategories.find(
          (a) =>
            a.market_category_id == el.market_category_id &&
            a.marketId == el.marketId
        );
        if (!res) uniqueCategories.push(el);
      });

      uniqueCategories.forEach((category) => {
        let activeClass = "hidden";

        if (category.mainCategory && category.mainCategoryID) {
          if (scrollMeContent == "") activeClass = "active";
          if (
            !scrollMeContent.includes(
              `data-target="${category.mainCategoryID}-module"`
            )
          ) {
            scrollMeContent += `
                            <a 
                                class="
                                    singleMatchCatBtn 
                                    flex-row 
                                    flex-wrap 
                                    text-white font-[400] 
                                    text-[12px] 
                                    leading-[25px] 
                                    cursor-pointer 
                                    h-[25px] 
                                    font-sans 
                                    space-x-1 
                                    px-2 
                                    items-center 
                                    ${
                                      !category.mainCategoryID ||
                                      category.mainCategoryID == "33"
                                        ? "active"
                                        : ""
                                    }
                                " 
                                data-target="${category.mainCategoryID}-module"
                            >
                                ${_t(category.mainCategory)}
                            </a>`;
          }
        }
        matchView = "";
        const a = groupMatches.filter(
          (a) =>
            (a[0].market_category_id == category.market_category_id &&
              a[0].market_id == category.marketId) ||
            (a[0].market_category_id == category.market_category_id &&
              category.marketId == -1)
        );

        let counter = a[0].length;
        if (a[0][0].special_value && a[0][0].special_value != "") {
          counter += 1;
        }
        let classDescription = "";
        switch (counter) {
          case 1:
            classDescription = "oneColumns";
            break;
          case 2:
            classDescription = "twoColumns";
            break;
          case 3:
            classDescription = "threeColumns";
            break;
          case 4:
            classDescription = "fourColumns";
            break;
          default:
            break;
        }
        if (a.length > 1) {
          matchView += `<div class="singleHeaderHolderLabel flex flex-row flex-wrap w-full">`;
          if (a[0][0].special_value && a[0][0].special_value != "") {
            matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}"></div>`;
          }
          if (a[0][0]) {
            if (upDownMarkets.includes(a[0][0].market_category_id)) {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">${_t(
                "Lart"
              )}</div>`;
            } else if (oneTwo.includes(a[0][0].market_category_id)) {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">${groupMatchHomeName}</div>`;
            } else {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">${_t(
                "Lart"
              )}</div>`;
            }
          }
          if (a[0][1]) {
            if (upDownMarkets.includes(a[0][1].market_category_id)) {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">X</div>`;
            } else if (oneTwo.includes(a[0][1].market_category_id)) {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">${
                classDescription == "fourColumns"
                  ? "X"
                  : `${groupMatchAwayName}`
              }</div>`;
            } else {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">${
                classDescription == "fourColumns" ? _t("Saktë") : _t("Poshtë")
              }</div>`;
            }
          }
          if (a[0][2]) {
            matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis w-full ${classDescription}">${
              classDescription == "fourColumns" &&
              oneTwo.includes(a[0][1].market_category_id)
                ? `${groupMatchAwayName}`
                : _t("Poshtë")
            }</div>`;
          }
          matchView += ` </div>`;
        }

        a.forEach((groupMatch) => {
          if (
            groupMatch[0].special_value &&
            groupMatch[0].special_value != ""
          ) {
            if (
              !groupMatch[0].market.includes("Larte Poshte me Pike") &&
              groupMatch[0].market.includes("Nr i gameve ne Setin")
            ) {
              matchView += `<div class="singleColumnModule 
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            labelBtn ${
                                              groupMatch[0].special_value ==
                                              "1.5"
                                                ? "pushMeSecond"
                                                : ""
                                            } ${
                groupMatch[0].special_value == "0.5" ? "pushMeFirst" : ""
              } ${classDescription}">
                                <span>${groupMatch[0].special_value}</span>
                            </div>`;
            }
          }
          groupMatch.forEach((match) => {
            if (
              match.mainCategoryID == "33" &&
              match.market == "Numri i Golave ne Ndeshje" &&
              (match.market_option == "Lart 1.5" ||
                match.market_option == "Poshte 1.5")
            ) {
              matchView += `
                                    <div 
                                        class="
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            singleColumnModule
                                            bettingBtn 
                                            bettingBtn 
                                            pushMeSecond 
                                            ${classDescription} 
                                            ${match.id}${
                match.special_value && match.special_value != "" ? "-span" : ``
              }
                                        " 
                                        match-is-live="1" 
                                        match-code="Live" 
                                        match-market-option="${
                                          match.market_option
                                        }" 
                                        match-market="${match.market}" 
                                        match-home-name="${match.home_team}" 
                                        match-away-name="${match.away_team}"
                                        match-odd="${Utils.formatNumber(
                                          match.odd
                                        )}" 
                                        game-id="${request.id}" 
                                        bet-id="${match.id}"
                                    >
                                        ${
                                          match.special_value &&
                                          match.special_value != ""
                                            ? ""
                                            : `<span>${_t(
                                                match.market_option
                                              )}</span>`
                                        }
                                        <span>${Utils.formatNumber(
                                          match.odd
                                        )}</span>
                                    </div>
                                `;
            } else if (
              match.mainCategoryID == "33" &&
              match.market == "Numri i Golave ne Ndeshje" &&
              (match.market_option == "Lart 0.5" ||
                match.market_option == "Poshte 0.5")
            ) {
              matchView += `
                                    <div 
                                        class="
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            singleColumnModule
                                            bettingBtn 
                                            bettingBtn 
                                            pushMeFirst 
                                            ${classDescription} 
                                            ${match.id}${
                match.special_value && match.special_value != "" ? "-span" : ``
              }
                                        "
                                        match-code="Live" 
                                        match-is-live="1" match-market-option="${
                                          match.market_option
                                        }" 
                                        match-market="${match.market}" 
                                        match-home-name="${match.home_team}" 
                                        match-away-name="${match.away_team}" 
                                        match-odd="${Utils.formatNumber(
                                          match.odd
                                        )}" 
                                        game-id="${request.id}" 
                                        bet-id="${match.id}"
                                    >
                                        ${
                                          match.special_value &&
                                          match.special_value != ""
                                            ? ""
                                            : `<span>${_t(
                                                match.market_option
                                              )}</span>`
                                        }
                                        <span>${Utils.formatNumber(
                                          match.odd
                                        )}</span>
                                    </div>
                                `;
            } else {
              matchView += `
                                    <div 
                                        class="
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            singleColumnModule
                                            bettingBtn 
                                            bettingBtn 
                                            ${classDescription} 
                                            ${match.id}${
                match.special_value && match.special_value != "" ? "-span" : ``
              }
                                        " 
                                        match-code="Live" 
                                        match-is-live="1" 
                                        match-market-option="${
                                          match.market_option
                                        }" 
                                        match-market="${match.market}" 
                                        match-home-name="${match.home_team}" 
                                        match-away-name="${match.away_team}" 
                                        match-odd="${Utils.formatNumber(
                                          match.odd
                                        )}" 
                                        game-id="${request.id}" 
                                        bet-id="${match.id}"
                                    >
                                        ${
                                          match.market.includes(
                                            "Larte Poshte me Pike"
                                          ) ||
                                          match.market.includes(
                                            "Nr i gameve ne Setin"
                                          )
                                            ? match.special_value &&
                                              match.special_value !== "" &&
                                              match.special_value !== null
                                              ? `<span>${_t(
                                                  match.market_option
                                                )}</span>`
                                              : `<span>${_t(
                                                  match.market_option
                                                )}</span>`
                                            : match.special_value &&
                                              match.special_value != ""
                                            ? ""
                                            : `<span>${_t(
                                                match.market_option
                                              )}</span>`
                                        }
                                        <span>${Utils.formatNumber(
                                          match.odd
                                        )}</span>
                                    </div>
                                `;
            }
          });
          if (!category.market_category_id) {
            groupMatchView += `
                                <div class="singleMatchBetModuleGroup ${
                                  !category.mainCategoryID ||
                                  category.mainCategoryID == "33"
                                    ? "active"
                                    : "hidden"
                                }"  data-content="${
              category.mainCategoryID
            }-module"  id="${groupMatch[0].market_id}">
                                    <div class="singleMatchBetModuleGroupHeader">
                                        <span class="titleMarketSearch">${_t(
                                          groupMatch[0].market
                                        )} ${
              category.mainCategoryID === cornerCategoryId
                ? `<number-of-corners>${
                    numberOfCorners ?? ""
                  }</number-of-corners>`
                : ""
            }</span>
                                    </div>
                                    <div class="singleMatchBetModuleGroupContent">
                                        ${matchView}
                                    </div>  
                                </div>
                            `;
            matchView = "";
          }
        });

        if (category.market_category_id && category.market_category_id > 0) {
          const uniqueMarkets = groupMatches
            .filter(
              (a) =>
                a &&
                a[0] &&
                a[0].market_category_id == category.market_category_id
            )
            .map((item) => item[0].market_id);
          const marketsClass = uniqueMarkets.join(" ");
          groupMatchView += `
                        <div class="singleMatchBetModuleGroup ${marketsClass} ${activeClass} ${
            a[0][0].market == "Numri i Golave ne Ndeshje" ? "fixThis" : ""
          }"  data-content="${a[0][0].mainCategoryID}-module">
                            <div id="${
                              a[0][0].market_id
                            }" class="contentMarketNull"> 
                                <div class="singleMatchBetModuleGroupHeader">
                                    <span class="titleMarketSearch">${_t(
                                      a[0][0].market
                                    )} ${
            category.mainCategoryID === cornerCategoryId
              ? `<number-of-corners>${
                  numberOfCorners ?? ""
                }</number-of-corners>`
              : ""
          }</span>
                                </div>
                                <div class="singleMatchBetModuleGroupContent">
                                    ${matchView}
                                </div>
                            </div>
                        </div>
                    `;
        }
      });
    }

    let view = /*html*/ `
            <div class="match-container flex flex-row flex-wrap w-full opacity-0 duration-300 ease-in-out" sport-id="${sportFieldId}">
                <div class="fieldStaticHolder flex flex-row flex-wrap w-full">
                    <div class="flex flex-row w-full bg-[rgba(66,66,66,.75)] text-center justify-center text-white text-[11px] font-bold p-2">${leagueName}</div>
                    <div class="singleMatchWrapper flex flex-row flex-wrap w-full">
                        <div class="singleFieldView liveInfoActive flex-row flex-wrap w-full">
                            <div
                              class="singleMatchLiveField relative w-full flex-row flex-wrap ${
                                sportFieldId == 20 ? "hidden" : "flex"
                              }"
                              ${sportFieldId == 20 ? "hidden" : ""}
                            >
                              ${
                                liveStreamId
                                  ? `
                                  <div class="liveMatchButtons absolute right-0 top-[-30px] z-10 flex flex-row flex-wrap bg-[#212121] border-[#3d3d3d]">
                                    ${
                                      sportFieldId == 1
                                        ? `<a href="#" class="liveMatchBtn flex p-1 active text-[#ffe600]" data-show="corner-field">🚩</a>`
                                        : ``
                                    }
                                    <a href="#" class="liveMatchBtn flex p-1 ${
                                      sportFieldId == 1
                                        ? ""
                                        : "active text-[#ffe600]"
                                    }" data-show="live-field">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                          viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                          class="feather feather-divide-square" style="transform: rotate(90deg)">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="8" y1="12" x2="16" y2="12"></line>
                                        <line x1="12" y1="16" x2="12" y2="16"></line>
                                        <line x1="12" y1="8"  x2="12" y2="8"></line>
                                      </svg>
                                    </a>
                                    <a href="#" class="liveMatchBtn flex p-1" data-show="live-stream" data-link="${liveStreamId}">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                          viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                          class="feather feather-monitor">
                                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                                        <line x1="8"  y1="21" x2="16" y2="21"></line>
                                        <line x1="12" y1="21" x2="12" y2="17"></line>
                                      </svg>
                                    </a>
                                  </div>
                                `
                                  : ""
                              }

                              <!-- CORNER FIELD — only for football, default visible when sportFieldId == 1 -->
                              ${
                                sportFieldId == 1
                                  ? `
                                  <div class="corner-field flex w-full min-h-[210px] bg-black/40 relative flex-wrap p-5">
                                    <div class="w-full text-center flex flex-row flex-wrap">
                                      <div class="[background-image:linear-gradient(to_top,#010101_20%,#2e2e2e_90%)] text-white text-[14px] font-bold px-2 w-full flex items-center">
                                        <span class="min-w-0 flex-1 text-right">
                                          <span class="block truncate">${groupMatchHomeName}</span>
                                        </span>
                                        <span class="w-[50px] shrink-0 text-center text-[15px] font-bold bg-[rgba(0,0,0,.25)] px-2">
                                          ${result.replace("-", ":")}
                                        </span>
                                        <span class="min-w-0 flex-1 text-left">
                                          <span class="block truncate">${groupMatchAwayName}</span>
                                        </span>
                                      </div>
                                    </div>
                                    <div id="corner-table" class="w-full"></div>
                                  </div>
                                  `
                                  : ``
                              }

                              <!-- LIVE FIELD — default visible for non-football; hidden when football (because corner is default) -->
                              <div class="live-field ${
                                sportFieldId == 1 ? "hidden" : ""
                              } relative flex w-full min-h-[210px] bg-black/40">
                                ${
                                  sportFieldId == 1
                                    ? `<iframe scrolling="no" class="absolute left-1/2 top-1/2 h-[90px] w-[200px] -translate-x-1/2 -translate-y-1/2 scale-[2.24]" id="iframe" src="${location.origin}/betting_p2p/a.html?id=${gameId}&lng=${lang}"></iframe>`
                                    : ""
                                }
                                ${
                                  sportFieldId == 2
                                    ? `<iframe scrolling="no" class="flex w-full" id="basketballIframe" src="${location.origin}/betting_p2p/c.html?id=${gameId}&lng=${lang}"></iframe>`
                                    : ""
                                }
                                ${
                                  sportFieldId == 5
                                    ? `<iframe scrolling="no" class="flex w-full" id="tennisIframe" src="${location.origin}/betting_p2p/b.html?id=${gameId}&lng=${lang}"></iframe>`
                                    : ""
                                }
                              </div>

                              <!-- LIVE STREAM (only if present) -->
                              ${
                                liveStreamId
                                  ? `<div class="live-stream hidden flex w-full min-h-[210px]"></div>`
                                  : ""
                              }
                            </div>


                        </div>
                    </div>
                </div>
                <div class="singleMatchBetModule m-t-240 singleFirstCatContainer active flex-wrap flex-row w-full" style="display: flex;" id="${gameId}-content">
                    <div class="timeline-wrapper flex flex-row flex-wrap w-full"></div>
                        <div class="flex items-center justify-between bg-black/40 w-full flex-row flex-wrap p-1">
                            <div class="flex flex-row flex-wrap">
                                ${scrollMeContent}
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row w-full hidden">
                            <span class="expander" game-api-id="${gameApiID}" style="position: absolute; right: -1px; padding: 8px; z-index: 2; top: 0; margin-top: 0;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clock"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            </span>
                        </div>
                        <div id="fixViewOn" class="flex flex-row flex-wrap w-full">
                            ${groupMatchView}
                        </div>
                    </div>
                </div>
            `;
    return view;
  },
  after_render: async (socket) => {
    if (blockedSportRedirect) return;

    localStorage.setItem("matchSport", "0");
    let groupMatches;
    let request = Utils.parseRequestURL();

    let hasChanged = false;
    let marketIdShown = false;
    let lastActive = $("body .singleMatchCatBtn.active").attr("data-target");
    $("body .fixThis .singleMatchBetModuleGroupContent").each(function (
      i,
      item
    ) {
      $(item)
        .children(".pushMeFirst")
        .wrapAll('<div class="groupRender first"></div>');
      $(item)
        .children(".pushMeSecond")
        .wrapAll('<div class="groupRender second"></div>');
      $(item)
        .children(".pushMeSecond")
        .wrapAll('<div class="groupRender third"></div>');
    });
    $("body .fixThis .singleMatchBetModuleGroupContent").each(function (
      i,
      item
    ) {
      let firstItemGroup = $(item).children(".first");
      let secondItemGroup = $(item).children(".second");
      let thirdItemGroup = $(item).children(".third");
      let titleHeader = $(item).children(".singleHeaderHolderLabel");

      // remove and re-prepend in new order
      $(item).children(".first").remove();
      $(item).children(".second").remove();
      $(item).children(".third").remove();

      $(item).prepend(thirdItemGroup);
      $(item).prepend(secondItemGroup);
      $(item).prepend(firstItemGroup);
      $(item).prepend(titleHeader);
    });

    // run after the loop is done
    setTimeout(() => {
      $("body .match-container").removeClass("opacity-0");
    }, 200);

    $("body").on("click", ".singleMatchCatBtn", function (e) {
      $("body .singleMatchCatBtn").removeClass(
        "active bg-[#8d741d] pointer-events-none"
      );
      $("body .singleMatchBetModuleGroup").removeClass(
        "active bg-[#8d741d] pointer-events-none"
      );
      $("body .singleMatchBetModuleGroup").addClass("hidden");
      lastActive = $(e.currentTarget).attr("data-target");
      $(e.currentTarget).addClass("active bg-[#8d741d] pointer-events-none");
      let putTriggerContent = $(e.currentTarget).attr("data-target");
      $("body .singleMatchBetModuleGroup").each(function (i, item) {
        if (
          $(item).attr("data-content") == putTriggerContent ||
          putTriggerContent == "17-module"
        ) {
          $(item).addClass("active");
          $(item).removeClass("hidden");
        }
      });
    });

    function delay(callback, ms) {
      var timer = 0;
      return function () {
        var context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    $("body").on(
      "keyup",
      "#searchMarketsId",
      delay(async function (e) {
        let marketMatchText = $("#searchMarketsId").val().toLowerCase();
        console.log(marketMatchText);

        if (marketMatchText == "") {
          $(".removeItem").removeClass("removeItem");
        } else {
          $("body .titleMarketSearch").each(function (i, item) {
            let valueOfMarket = $(item).text().toLowerCase();
            console.log(item, ";item");
            console.log(valueOfMarket, "itemi i kerkuarrr");
            if (!valueOfMarket.includes(marketMatchText)) {
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".contentMarketNull")
                .parent(".singleMatchBetModuleGroup ")
                .addClass("removeItem");
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".singleMatchBetModuleGroup ")
                .addClass("removeItem");
            } else {
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".contentMarketNull")
                .parent(".singleMatchBetModuleGroup ")
                .removeClass("removeItem");
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".singleMatchBetModuleGroup ")
                .removeClass("removeItem");
            }
          });
        }
      }, 300)
    );

    socket.on("delete-live-game", (data) => {
      if (gameId == data.id) {
        const event = new CustomEvent("leaveRoom", {
          detail: gameId,
        });
        window.dispatchEvent(event);
        window.location.href = "#/InPlay";
      }
    });

    //socket.emit('connectToRoom', {room: gameId});
    const event = new CustomEvent("addToRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);

    socket.on("new-coefs", (res) => {
      if (res.game_id == gameId) {
        const userGroup = getUserGroup();
        res.coefs.forEach((data) => {
          data = transformSingleCoef(data, userGroup);

          let div = document.querySelector(`[bet-id="${data.coef_id}"]`);
          const span = document.getElementsByClassName(
            data.coef_id + "-span"
          )[0];

          if (!div) {
            hasChanged = false;
          }
          if (span && !div) {
            return;
          }

          if (div) {
            div.innerHTML = getInsideSingleColumn(
              data.market_option_name,
              data.odd
            );
            document
              .querySelector(`[bet-id="${data.coef_id}"]`)
              .setAttribute("match-odd", Utils.formatNumber(data.odd));
          } else {
            let market = document.getElementById(data.market_id);
            if (!market) {
              market = document.getElementsByClassName(data.market_id);
              if (market && market.length > 0) {
                market = market[0];
              }
            }
            // let marketContent = document.getElementById(
            //   data.market_id + "-content"
            // );
            const newSingleCoefTemplate = getSingleColumnModule(
              {
                home_team: groupMatchHomeName,
                away_team: groupMatchAwayName,
                market_option: data.market_option_name,
                market: data.market_id,
                odd: data.odd,
                id: data.coef_id,
                market_name: data.market_name,
              },
              { id: data.game_id }
            );
            if (!market) {
              if (data.odd != "1.00") {
                let mainContainer = document.getElementById(
                  `${gameId}-content`
                );
                if (mainContainer) {
                  mainContainer.innerHTML += `<div class="singleMatchBetModuleGroup flex flex-wrap flex-row w-full" id=${
                    data.market_id
                  }>
                                        <div class="singleMatchBetModuleGroupHeader flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-yellow-400 bg-black/70 items-center mb-[1px] space-x-1">
                                            <img class="flex flex-wrap flex-row w-[19px] h-[19px]" src="./img/1.png">
                                            <span class="titleMarketSearch flex flex-wrap flex-row pt-[1px]">${_t(
                                              data.market_name
                                            )}</span>
                                        </div>
                                        <div class="singleMatchBetModuleGroupContent flex flex-row flex-wrap w-full">
                                            ${newSingleCoefTemplate}
                                        </div>
                                    </div>`;
                }
              } else {
                let div = document.getElementsByClassName(data.coef_id)[0];
                if (div) {
                  div.innerHTML = getInsideSingleColumn(
                    data.market_option_name,
                    data.odd
                  );
                  document
                    .getElementsByClassName(data.coef_id)[0]
                    .setAttribute("match-odd", Utils.formatNumber(data.odd));
                }
              }
            } else {
              if (market && market.getElementsByClassName) {
                const marketContent = market.getElementsByClassName(
                  "singleMatchBetModuleGroupContent"
                );
                if (data.odd != "1.00" && marketContent && marketContent[0]) {
                  marketContent[0].innerHTML += newSingleCoefTemplate;
                }
              }
            }
          }
        });
        updateMatch();

        try {
          if (res.current_result) {
            const result = res.current_result.split("-");
            if (result.length === 2) {
              if ($(".matchVersusName i b:first-child").text() !== result[0]) {
                $(".matchVersusName i b:first-child").text(result[0]);
              }
              if ($(".matchVersusName i b:last-child").text() !== result[1]) {
                $(".matchVersusName i b:last-child").text(result[1]);
              }
            }
          }
        } catch {
          console.log("pose");
        }
      }
    });

    if ($(window).width() <= 600) {
      let scrollWidth = 0;
      let scrollMeWidth = 0;

      scrollMeWidth += $("body .singleCategoryTitle").width();
      scrollMeWidth += $("body .matchVersusName").width();

      $(".singleMatchScrolLMeName").width(scrollMeWidth + 15);

      $("body .singleMatchCatBtn").each(function () {
        scrollWidth += $(this).width() + 10;
      });
      $("body .scrollMe").css({
        width: scrollWidth + "px",
      });

      sportFieldId = localStorage.getItem("inplay-sportid");
      if (sportFieldId == 1) {
        var p = $("#iframe");
        var position = p.position();
      }

      let getIframeHeight = $("body #iframe").height();
      $("body #iframe").css({
        height: getIframeHeight + 33 + "px",
      });
      $("body #iframe")
        .parent()
        .css({
          height: getIframeHeight + 53 + "px",
          position: "relative",
        });
    }

    $("body .singleMatchBetModuleGroup").each(function (e) {
      if (!$(this).attr("id") || $(this).attr("id") == "undefined") {
        $(this).addClass("twoColumn");
      }

      let countChildren = $(this)
        .children(".singleMatchBetModuleGroupContent")
        .children(".singleColumnModule ").length;
      if (countChildren == 2) {
        $(this).addClass("twoColumn");
      }

      if (
        !$(this)
          .children(".contentMarketNull")
          .children(".singleMatchBetModuleGroupContent")
          .children(".singleColumnModule.labelBtn").length == 0
      ) {
        $(this).removeClass("twoColumn");
        $(this)
          .children(".contentMarketNull")
          .children(".singleMatchBetModuleGroupContent")
          .children(".singleColumnModule.labelBtn")
          .addClass("disabledBtn");
      }
    });

    $("body").addClass("livePage");

    // Toggle between: corner-field, live-field, live-stream
    $("body").on("click", ".liveMatchButtons .liveMatchBtn", function (e) {
      e.preventDefault();

      const $btn = $(this);
      if ($btn.hasClass("active")) return; // already active, no-op

      const target = $btn.data("show"); // "corner-field" | "live-field" | "live-stream"
      const $root = $btn.closest(".singleMatchLiveField");

      // Active state
      $btn
        .addClass("active text-[#ffe600]")
        .siblings(".liveMatchBtn")
        .removeClass("active text-[#ffe600]");

      // Hide all panels in this widget
      const $corner = $root.find(".corner-field");
      const $live = $root.find(".live-field");
      const $stream = $root.find(".live-stream");

      $corner.hide();
      $live.hide();
      $stream.hide().empty(); // also clear any previous iframe when leaving

      if (target === "live-stream") {
        const link = $btn.data("link");
        $stream.show().empty(); // ensure fresh container

        // Only fetch/embed if we have a link resolver
        if (typeof getLiveStreamLink === "function" && link) {
          getLiveStreamLink(link).then((res) => {
            if (res && res.success === true && res.url) {
              $("<iframe>", {
                src: res.url,
                id: "gameIframe",
                frameborder: 0,
                noresize: "noresize",
                allow: "geolocation 'self'; autoplay 'self'",
                class: "live-stream-iframe w-full h-full",
              }).appendTo($stream);
            }
          });
        }
      } else if (target === "live-field") {
        $live.show();
      } else if (target === "corner-field") {
        $corner.show();
        // Optional: refresh corners when switching in
        if (typeof fetchCornerData === "function") fetchCornerData();
      }
    });

    $(".newCatHolder .expander").unbind("click");
    $(".newCatHolder .expander").click(async function (e) {
      e.preventDefault();
      $(this).toggleClass("open");
      var $timelineWrapper = $(".singleMatchBetModule .timeline-wrapper");
      if ($(this).hasClass("open")) {
        var gameId = $(this).attr("game-api-id");
        var timeline = await Timeline.render(gameId);
        $timelineWrapper.html(timeline);
        Timeline.refreshTimeline(gameId);
      } else {
        $timelineWrapper.html("");
      }
    });

    let scrollMeWidth = 0;
    $("body .scroller")
      .children()
      .each(function (i, item) {
        scrollMeWidth += $(item).outerWidth(true) + 1;
      });

    $("body .scroller").css({
      width: scrollMeWidth + "px",
    });

    $('*[data-target="17-module"]').click();

    function renderIncidentTable(
      items,
      {
        container = "body #corner-table",
        clockLabel = "00:00",
        homeName = "",
        awayName = "",
        sportFieldId = 1, // pass the real one
      } = {}
    ) {
      const zero = () => ({ goal: 0, yellow: 0, red: 0, corner: 0 });
      const tallies = { 1: zero(), 2: zero() };

      for (const it of Array.isArray(items) ? items : []) {
        const t =
          it.team && (it.team === "1" || it.team === "2") ? it.team : null;
        if (!t) continue;
        const type = (it.type || "").toLowerCase();
        if (type === "corner") tallies[t].corner++;
        else if (type === "yellow card") tallies[t].yellow++;
        else if (type === "red card") tallies[t].red++;
        else if (type.includes("goal")) tallies[t].goal++;
      }

      // --- Helpers ---
      function parseMinuteStr(s) {
        const m = String(s || "")
          .trim()
          .match(/^(\d{1,3}):([0-5]\d)$/);
        if (!m) return 0;
        return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
      }
      function formatMMSS(totalSeconds) {
        const m = Math.floor(totalSeconds / 60);
        const s = totalSeconds % 60;
        return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
      }
      function halfLabel(totalSeconds) {
        return totalSeconds <= 45 * 60 ? "Pjesa e pare" : "Pjesa e dyte";
      }

      // --- Timer per-match ---
      function startFootballClock($root, initialMinuteStr, sportFieldId) {
        if (Number(sportFieldId) !== 1) return; // football only

        const prevId = $root.data("minuteTimerId");
        if (prevId) {
          clearInterval(prevId);
          $root.removeData("minuteTimerId");
        }

        let totalSeconds = parseMinuteStr(initialMinuteStr || "00:00");

        // Initial paint
        $root.find(".js-current-minute").text(formatMMSS(totalSeconds));
        $root.find(".js-half-label").text(halfLabel(totalSeconds));

        const id = setInterval(() => {
          totalSeconds += 1;
          $root.find(".js-current-minute").text(formatMMSS(totalSeconds));
          $root.find(".js-half-label").text(halfLabel(totalSeconds));
        }, 1000);

        $root.data("minuteTimerId", id);
      }

      const html = `
        <div class="here-is-clock">
          <div class="bg-neutral-900 text-gray-200 overflow-hidden w-full max-w-lg">
            <table class="w-full border-collapse table-fixed text-sm">
              <thead>
                <tr class="border-b border-neutral-500">
                  <th class="w-4/6 text-left border-r border-neutral-500 px-3 py-2">
                    <span class="js-half-label mr-2"></span>
                    <span class="js-current-minute tabular-nums hidden">${
                      clockLabel || "00:00"
                    }</span>
                  </th>
                  <th class="w-[20px] text-center border-r border-neutral-500 px-2 py-1">⚽</th>
                  <th class="w-[20px] text-center border-r border-neutral-500 px-2 py-1">🟨</th>
                  <th class="w-[20px] text-center border-r border-neutral-500 px-2 py-1">🟥</th>
                  <th class="w-[20px] text-center px-2 py-1">🚩</th>
                </tr>
              </thead>
              <tbody class="text-[11px]">
                <tr class="border-b border-neutral-500">
                  <th class="text-left w-4/6 border-r border-neutral-500 font-medium text-white py-1 px-2">${homeName}</th>
                  <td class="text-center border-r border-neutral-500 py-1 tabular-nums">${
                    tallies["1"].goal
                  }</td>
                  <td class="text-center border-r border-neutral-500 py-1 tabular-nums">${
                    tallies["1"].yellow
                  }</td>
                  <td class="text-center border-r border-neutral-500 py-1 tabular-nums">${
                    tallies["1"].red
                  }</td>
                  <td class="text-center py-1 tabular-nums">${
                    tallies["1"].corner
                  }</td>
                </tr>
                <tr>
                  <th class="text-left w-3/5 border-r border-neutral-500 font-medium text-white py-1 px-2">${awayName}</th>
                  <td class="text-center border-r border-neutral-500 py-1 tabular-nums">${
                    tallies["2"].goal
                  }</td>
                  <td class="text-center border-r border-neutral-500 py-1 tabular-nums">${
                    tallies["2"].yellow
                  }</td>
                  <td class="text-center border-r border-neutral-500 py-1 tabular-nums">${
                    tallies["2"].red
                  }</td>
                  <td class="text-center py-1 tabular-nums">${
                    tallies["2"].corner
                  }</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      `;

      // Inject then start the clock (scope to this container)
      $(container).html(html);
      const $matchRoot = $(`${container} .here-is-clock`);
      startFootballClock($matchRoot, clockLabel, sportFieldId);
    }

    async function fetchCornerData() {
      if (!gameApiID) return;

      // Only show the corner table for football; clear otherwise
      if (Number(sportFieldId) !== 1) {
        $("body #corner-table").empty();
        return;
      }

      const URL = `${location.origin}/games-timeline/${gameApiID}.json`;

      // Fixed fallback timeline (your sample)
      const DEFAULT_TIMELINE = [
        {
          type: "Corner",
          type_id: "2",
          team: "1",
          value: "1",
          game_status: "1",
          minute: "00:00",
        },
      ];

      // Helper: last valid MM:SS for the clock
      const lastClockLabel = (list) => {
        for (let i = list.length - 1; i >= 0; i--) {
          const m = String(list[i]?.minute || "");
          if (/^\d{1,3}:[0-5]\d$/.test(m)) return m;
        }
        return "00:00";
      };

      // Single render path used in success/fail
      const renderWith = (timeline) => {
        renderIncidentTable(timeline, {
          container: "body #corner-table",
          clockLabel: lastClockLabel(timeline),
          homeName: groupMatchHomeName || "",
          awayName: groupMatchAwayName || "",
          sportFieldId, // only runs the live clock for football
        });

        // Update the "[x:y]" corners badge
        const corners = timeline.filter(
          (i) => (i.type || "").toLowerCase() === "corner"
        );
        const left = corners.filter((c) => c.team === "1").length || 0;
        const right = corners.filter((c) => c.team === "2").length || 0;
        numberOfCorners = `[${left}:${right}]`;
        $("number-of-corners").text(numberOfCorners);
      };

      // KEEP .getJSON — add fallback on empty/invalid or on network error
      $.getJSON(URL, function (items) {
        const timeline =
          Array.isArray(items) && items.length ? items : DEFAULT_TIMELINE;
        renderWith(timeline);
      }).fail(function () {
        // Network / server error -> fallback
        renderWith(DEFAULT_TIMELINE);
      });
    }

    fetchCornerData();
    cornerRefreshInterval = setInterval(fetchCornerData, 5000);

    async function fetchMarketData() {
      const path = `livematch/${request.id}`;
      while (location.hash.includes(path)) {
        try {
          const response = await makeRequest();
          const games = response[0];

          if (games.length > 0) {
            multipeResults = parseResultList(
              games[0].result,
              games[0].result_list,
              false,
              sportFieldId
            );
            $(".matchVersusName.multiple-results .results").html(
              multipeResults
            );
          }

          for (const game of games) {
            if (game.market_id == null) {
              marketIdShown = false;
              hasChanged = false;
              $("body #fixViewOn").html("");
              $("body .scroller").html("");
              break;
            } else {
              marketIdShown = true;
              groupMatches = response;
            }
          }

          if (marketIdShown && !hasChanged) {
            fixView();
          }

          if (!location.hash.includes("livematch")) {
            break;
          }
          await delays(5000);
        } catch (error) {
          console.error("Error:", error);
        }
      }
    }

    function delays(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    async function makeRequest() {
      return await getLiveMatch(request.id);
    }
    fetchMarketData().catch((err) => {
      console.error("Error in fetchMarketData:", err);
    });

    const fixView = async () => {
      hasChanged = true;

      let upDownMarkets = [12, 16];
      let oneTwo = [7, 8, 9, 18];

      let groupMatchView = "";
      let matchView = "";
      let groupMatchDate = "";
      let scrollMeContent = "";
      let result = "";

      try {
        if (groupMatches.length > 0) {
          liveStreamId = groupMatches[0][0].stream_id;
          gameApiID = groupMatches[0][0].game_api_id;
        }
      } catch {}

      if (!groupMatches.length) {
        window.history.back();
        return;
      }

      groupMatchHomeName = `${groupMatches[0][0].home_team}`;
      groupMatchAwayName = `${groupMatches[0][0].away_team}`;
      groupMatchDate = `${groupMatches[0][0].game_date}`;
      result = groupMatches[0][0].result;

      if (
        !(
          groupMatches.length == 1 &&
          groupMatches[0].length == 1 &&
          !groupMatches[0][0].odd
        )
      ) {
        let acc = groupMatches.map(function (item) {
          return {
            market_category_id: item[0].market_category_id,
            mainCategory: item[0].mainCategory,
            mainCategoryID: item[0].mainCategoryID,
            marketId: item[0].market_category_id ? -1 : item[0].market_id,
          };
        });

        const uniqueCategories = [];

        $.each(acc, function (i, el) {
          const res = uniqueCategories.find(
            (a) =>
              a.market_category_id == el.market_category_id &&
              a.marketId == el.marketId
          );
          if (!res) uniqueCategories.push(el);
        });

        uniqueCategories.forEach((category) => {
          let activeClass = "hidden";
          // console.log(category);
          if (category.mainCategory && category.mainCategoryID) {
            if (scrollMeContent == "") activeClass = "active";
            if (
              !scrollMeContent.includes(
                `data-target="${category.mainCategoryID}-module"`
              )
            ) {
              scrollMeContent += `
                                <a 
                                    class="
                                        singleMatchCatBtn 
                                        flex-row 
                                        flex-wrap 
                                        text-white font-[400] 
                                        text-[12px] 
                                        leading-[25px] 
                                        cursor-pointer 
                                        h-[25px] 
                                        font-sans 
                                        space-x-1 
                                        px-2 
                                        items-center 
                                        ${
                                          !category.mainCategoryID ||
                                          category.mainCategoryID == "33"
                                            ? "flex"
                                            : ""
                                        }
                                    " 
                                    data-target="${
                                      category.mainCategoryID
                                    }-module"
                                >
                                    ${_t(category.mainCategory)}
                                </a>`;
            }
          }
          matchView = "";
          const a = groupMatches.filter(
            (a) =>
              (a[0].market_category_id == category.market_category_id &&
                a[0].market_id == category.marketId) ||
              (a[0].market_category_id == category.market_category_id &&
                category.marketId == -1)
          );

          let counter = a[0].length;
          if (a[0][0].special_value && a[0][0].special_value != "") {
            counter += 1;
          }
          let classDescription = "";
          switch (counter) {
            case 1:
              classDescription = "oneColumns";
              break;
            case 2:
              classDescription = "twoColumns";
              break;
            case 3:
              classDescription = "threeColumns";
              break;
            case 4:
              classDescription = "fourColumns";
              break;
            default:
              break;
          }
          if (a.length > 1) {
            matchView += `<div class="singleHeaderHolderLabel flex flex-row flex-wrap w-full">`;
            if (a[0][0].special_value && a[0][0].special_value != "") {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}"></div>`;
            }
            if (a[0][0]) {
              if (upDownMarkets.includes(a[0][0].market_category_id)) {
                matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">${_t(
                  "Lart"
                )}</div>`;
              } else if (oneTwo.includes(a[0][0].market_category_id)) {
                matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">${groupMatchHomeName}</div>`;
              } else {
                matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">${_t(
                  "Lart"
                )}</div>`;
              }
            }
            if (a[0][1]) {
              if (upDownMarkets.includes(a[0][1].market_category_id)) {
                matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">X</div>`;
              } else if (oneTwo.includes(a[0][1].market_category_id)) {
                matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">${
                  classDescription == "fourColumns"
                    ? "X"
                    : `${groupMatchAwayName}`
                }</div>`;
              } else {
                matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">${
                  classDescription == "fourColumns" ? _t("Saktë") : _t("Poshtë")
                }</div>`;
              }
            }
            if (a[0][2]) {
              matchView += `<div class="singleHeaderLabel text-[rgba(255,255,255,0.5)] truncate whitespace-nowrap overflow-hidden text-ellipsis flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] w-full ${classDescription}">${
                classDescription == "fourColumns" &&
                oneTwo.includes(a[0][1].market_category_id)
                  ? `${groupMatchAwayName}`
                  : _t("Poshtë")
              }</div>`;
            }
            matchView += ` </div>`;
          }

          a.forEach((groupMatch) => {
            if (
              groupMatch[0].special_value &&
              groupMatch[0].special_value != ""
            ) {
              if (
                !groupMatch[0].market.includes("Larte Poshte me Pike") &&
                !groupMatch[0].market.includes("Nr i gameve ne Setin")
              ) {
                matchView += `<div class="singleColumnModule
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/05
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            border-r
                                            border-[#3d3d3d]
                                            mb-[1px] 
                                            opacity-1/2
                                            labelBtn 
                                            ${
                                              groupMatch[0].special_value ==
                                              "1.5"
                                                ? "pushMeSecond"
                                                : ""
                                            } 
                                            ${
                                              groupMatch[0].special_value ==
                                              "0.5"
                                                ? "pushMeFirst"
                                                : ""
                                            } 
                                            ${classDescription}"
                                        >
                                    <span>${groupMatch[0].special_value}</span>
                                </div>`;
              }
            }
            groupMatch.forEach((match) => {
              if (
                match.mainCategoryID == "33" &&
                match.market == "Numri i Golave ne Ndeshje" &&
                (match.market_option == "Lart 1.5" ||
                  match.market_option == "Poshte 1.5")
              ) {
                matchView += `
                                    <div 
                                        class="
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            singleColumnModule
                                            bettingBtn
                                            pushMeSecond 
                                            ${classDescription} 
                                            ${match.id}${
                  match.special_value && match.special_value != ""
                    ? "-span"
                    : ``
                }
                                        " 
                                        match-code="${match.game_code || "-"}" 
                                        match-is-live="1" 
                                        match-market-option="${
                                          match.market_option
                                        }" 
                                        match-market="${match.market}" 
                                        match-home-name="${match.home_team}" 
                                        match-away-name="${match.away_team}"
                                        match-odd="${Utils.formatNumber(
                                          match.odd
                                        )}" 
                                        game-id="${request.id}" 
                                        bet-id="${match.id}"
                                    >
                                        ${
                                          match.special_value &&
                                          match.special_value != ""
                                            ? ""
                                            : `<span>${_t(
                                                match.market_option
                                              )}</span>`
                                        }
                                        <span class="font-bold">${Utils.formatNumber(
                                          match.odd
                                        )}</span>
                                    </div>
                                `;
              } else if (
                match.mainCategoryID == "33" &&
                match.market == "Numri i Golave ne Ndeshje" &&
                (match.market_option == "Lart 0.5" ||
                  match.market_option == "Poshte 0.5")
              ) {
                matchView += `
                                    <div 
                                        class="
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            singleColumnModule
                                            bettingBtn 
                                            pushMeFirst 
                                            ${classDescription} 
                                            ${match.id}${
                  match.special_value && match.special_value != ""
                    ? "-span"
                    : ``
                }
                                        " 
                                        match-code="${match.game_code || "-"}" 
                                        match-is-live="1" match-market-option="${
                                          match.market_option
                                        }" 
                                        match-market="${match.market}" 
                                        match-home-name="${match.home_team}" 
                                        match-away-name="${match.away_team}" 
                                        match-odd="${Utils.formatNumber(
                                          match.odd
                                        )}" 
                                        game-id="${request.id}" 
                                        bet-id="${match.id}"
                                    >
                                        ${
                                          match.special_value &&
                                          match.special_value != ""
                                            ? ""
                                            : `<span>${_t(
                                                match.market_option
                                              )}</span>`
                                        }
                                        <span class="font-bold">${Utils.formatNumber(
                                          match.odd
                                        )}</span>
                                    </div>
                                `;
              } else {
                matchView += `
                                    <div 
                                        class="
                                            justify-between
                                            flex 
                                            flex-wrap 
                                            flex-row  
                                            bg-black/20
                                            text-white
                                            duration-300
                                            ease-in-out
                                            text-[11px]
                                            px-1
                                            py-[1px]
                                            cursor-pointer
                                            border-r
                                            border-[#3d3d3d]
                                            hover:bg-[#8d741d]
                                            mb-[1px]
                                            singleColumnModule
                                            bettingBtn  
                                            ${classDescription} 
                                            ${match.id}${
                  match.special_value && match.special_value != ""
                    ? "-span"
                    : ``
                }
                                        " 
                                        match-code="${match.game_code || "-"}" 
                                        match-is-live="1" 
                                        match-market-option="${
                                          match.market_option
                                        }" 
                                        match-market="${match.market}" 
                                        match-home-name="${match.home_team}" 
                                        match-away-name="${match.away_team}" 
                                        match-odd="${Utils.formatNumber(
                                          match.odd
                                        )}" 
                                        game-id="${request.id}" 
                                        bet-id="${match.id}"
                                    >
                                    ${
                                      match.market.includes(
                                        "Larte Poshte me Pike"
                                      ) ||
                                      match.market.includes(
                                        "Nr i gameve ne Setin"
                                      )
                                        ? match.special_value &&
                                          match.special_value !== "" &&
                                          match.special_value !== null
                                          ? `<span>${_t(
                                              match.market_option
                                            )}</span>`
                                          : `<span>${_t(
                                              match.market_option
                                            )}</span>`
                                        : match.special_value &&
                                          match.special_value != ""
                                        ? ""
                                        : `<span>${_t(
                                            match.market_option
                                          )}</span>`
                                    }
                                    <span class="font-bold">${(
                                      Math.floor(
                                        (parseFloat(match.odd) +
                                          Number.EPSILON) *
                                          100
                                      ) / 100
                                    ).toFixed(2)}</span>
                                </div>`;
              }
            });
            if (!category.market_category_id) {
              groupMatchView += `<div class="singleMatchBetModuleGroup flex flex-wrap flex-row w-full ${
                !category.mainCategoryID || category.mainCategoryID == "33"
                  ? "active"
                  : ""
              }"  data-content="${category.mainCategoryID}-module"  id="${
                groupMatch[0].market_id
              }">
                                    <div class="singleMatchBetModuleGroupHeader flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-yellow-400 bg-black/70 items-center mb-[1px] space-x-1">
                                        <img class="flex flex-wrap flex-row w-[19px] h-[19px]" src="./img/1.png">
                                        <span class="titleMarketSearch flex flex-wrap flex-row pt-[1px]">${_t(
                                          groupMatch[0].market
                                        )}</span>
                                    </div>
                                    <div class="singleMatchBetModuleGroupContent flex flex-row flex-wrap w-full">
                                        ${matchView}
                                    </div>
                                </div>`;
              matchView = "";
            }
          });

          if (category.market_category_id && category.market_category_id > 0) {
            const uniqueMarkets = groupMatches
              .filter(
                (a) =>
                  a &&
                  a[0] &&
                  a[0].market_category_id == category.market_category_id
              )
              .map((item) => item[0].market_id);
            const marketsClass = uniqueMarkets.join(" ");
            groupMatchView += `<div class="singleMatchBetModuleGroup flex flex-wrap flex-row w-full ${marketsClass} ${activeClass} ${
              a[0][0].market == "Numri i Golave ne Ndeshje" ? "fixThis" : ""
            }"  data-content="${a[0][0].mainCategoryID}-module">
                            <div id="${
                              a[0][0].market_id
                            }" class="contentMarketNull flex flex-wrap flex-row w-full"> 
                                <div class="singleMatchBetModuleGroupHeader flex flex-wrap flex-row w-full text-[11px] leading-[19px] font-normal text-left text-yellow-400 bg-black/70 items-center mb-[1px] space-x-1">
                                    <img class="flex flex-wrap flex-row w-[19px] h-[19px]" src="./img/1.png">
                                    <span class="titleMarketSearch flex flex-wrap flex-row pt-[1px]">${_t(
                                      a[0][0].market
                                    )} ${
              a[0][0].mainCategoryID === cornerCategoryId
                ? `<number-of-corners>${
                    numberOfCorners ?? ""
                  }</number-of-corners>`
                : ""
            }</span>
                                </div>
                                <div class="singleMatchBetModuleGroupContent flex flex-row flex-wrap w-full">
                                    ${matchView}
                                </div>
                            </div>
                        </div>`;
          }
        });
      }

      $("body #fixViewOn").html(groupMatchView);
      $("body .scroller").html(scrollMeContent);

      $("body .fixThis .singleMatchBetModuleGroupContent").each(function (
        i,
        item
      ) {
        $(item)
          .children(".pushMeFirst")
          .wrapAll(
            '<div class="groupRender flex flex-row flex-wrap w-full first"></div>'
          );
        $(item)
          .children(".pushMeSecond")
          .wrapAll(
            '<div class="groupRender flex flex-row flex-wrap w-full second"></div>'
          );
        $(item)
          .children(".pushMeSecond")
          .wrapAll(
            '<div class="groupRender flex flex-row flex-wrap w-full third"></div>'
          );
      });
      $("body .fixThis .singleMatchBetModuleGroupContent").each(function (
        i,
        item
      ) {
        let firstItemGroup = $(item).children(".first");
        let secondItemGroup = $(item).children(".second");
        let thirdItemGroup = $(item).children(".third");
        let titleHeader = $(item).children(".singleHeaderHolderLabel");

        $(item).children(".first").remove();
        $(item).children(".second").remove();
        $(item).children(".third").remove();

        $(item).prepend(thirdItemGroup);
        $(item).prepend(secondItemGroup);
        $(item).prepend(firstItemGroup);
        $(item).prepend(titleHeader);
      });

      $("body .singleMatchBetModuleGroup").each(function (e) {
        if (!$(this).attr("id") || $(this).attr("id") == "undefined") {
          $(this).addClass("twoColumn");
        }

        let countChildren = $(this)
          .children(".singleMatchBetModuleGroupContent")
          .children(".singleColumnModule ").length;
        if (countChildren == 2) {
          $(this).addClass("twoColumn");
        }
        if (
          !$(this)
            .children(".contentMarketNull")
            .children(".singleMatchBetModuleGroupContent")
            .children(".singleColumnModule.labelBtn").length == 0
        ) {
          $(this).removeClass("twoColumn");
          $(this)
            .children(".contentMarketNull")
            .children(".singleMatchBetModuleGroupContent")
            .children(".singleColumnModule.labelBtn")
            .addClass("disabledBtn");
        }
      });

      $(".newCatHolder .expander").unbind("click");
      $(".newCatHolder .expander").click(async function (e) {
        e.preventDefault();
        $(this).toggleClass("open");
        var $timelineWrapper = $(".singleMatchBetModule .timeline-wrapper");
        if ($(this).hasClass("open")) {
          var gameId = $(this).attr("game-api-id");
          var timeline = await Timeline.render(gameId);
          $timelineWrapper.html(timeline);
          Timeline.refreshTimeline(gameId);
        } else {
          $timelineWrapper.html("");
        }
      });

      setTimeout(() => {
        let scrollMeWidthss = 0;
        $("body .scroller")
          .children()
          .each(function (i, item) {
            scrollMeWidthss += $(item).outerWidth(true);
          });
        $("body .scroller").css({
          width: scrollMeWidthss + 10 + "px",
        });
      }, 50);
      if (lastActive === undefined) {
        $(`body .singleMatchCatBtn:first-child`).click();
      } else {
        $(`body .singleMatchCatBtn[data-target="${lastActive}"]`).click();
      }
    };
  },
  on_unload: async (socket) => {
    socket.emit("leaveRoom", { room: gameId });
    const event = new CustomEvent("leaveRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);
    clearInterval(cornerRefreshInterval);
  },
};

export default LiveMatch;
